import { render, staticRenderFns } from "./ThePublisherDashboard.vue?vue&type=template&id=6822fedc&"
import script from "./ThePublisherDashboard.vue?vue&type=script&lang=js&"
export * from "./ThePublisherDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ThePublisherDashboard.vue?vue&type=style&index=0&id=6822fedc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports